<template>
  <div class="im-action" @click="$emit('click')">
    <div class="im-action__icon" v-bind:class="'im-action__icon_' + icon">
      <svg>
        <use v-bind="{ 'xlink:href': '#icon-' + icon }"></use>
      </svg>
    </div>
    <div class="im-action__text">{{ title }}</div>
  </div>
</template>

<script>
  export default {
    name: 'Action',
    props: {
      title: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss">
  .im-action {
    $root: &;

    display: flex;
    align-items: center;
    border-bottom: 1px solid #D6D6D6;
    padding: 12px 0;

    &__icon {
      width: 20px;
      height: 20px;

      svg {
        fill: #8D96A1;
        width: 20px;
        height: 20px;
      }

      &_add {
        svg {
          fill: #36B274;
        }
      }

      &_ignore {
        svg {
          fill: #E54545;
        }
      }

      &_gift {
        svg {
          fill: #1588E2;
        }
      }

      &_history {
        svg {
          fill: #36B274;
        }
      }

      &_refresh {
        svg {
          fill: #1588E2;
        }
      }

      &_spam {
        svg {
          fill: #E54545;
        }
      }
    }

    &__text {
      cursor: pointer;
      margin: 0 0 0 10px;
      font-size: 13px;
      line-height: 20px;
      color: #8D96A1;

      &:hover {
        color: #1588E2;
      }
    }

    &:last-child {
      border: none;
      padding-bottom: 0;
    }
  }

</style>